import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SponsorLogoUpload from '../sponsors/SponsorLogoUpload';

const SponsorItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  background: #f8fafc;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SponsorInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const SponsorLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 0.25rem;
  object-fit: contain;
  background: white;
  border: 1px solid #e2e8f0;
`;

const SponsorSection = styled.div`
  margin-top: 1.5rem;
  padding: 1.5rem;
  background: white;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
`;

const RemoveButton = styled.button`
  padding: 0.5rem 1rem;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #dc2626;
    transform: translateY(-1px);
  }
`;

const AddButton = styled.button`
  padding: 0.5rem 1rem;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #059669;
    transform: translateY(-1px);
  }
`;

const Input = styled.input`
  flex: 1;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

const InputGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const SponsorManagement = ({ 
  sponsors, 
  tempSponsorName, 
  onAddSponsor, 
  onRemoveSponsor, 
  onLogoUpload, 
  onTempSponsorNameChange 
}) => {
  return (
    <SponsorSection>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Sponsors</h3>
      
      <InputGroup>
        <Input
          type="text"
          value={tempSponsorName}
          onChange={(e) => onTempSponsorNameChange(e.target.value)}
          placeholder="Enter sponsor name"
        />
        <AddButton onClick={onAddSponsor}>
          Add Sponsor
        </AddButton>
      </InputGroup>

      {(sponsors || []).map((sponsor, index) => (
        <SponsorItem key={index}>
          <SponsorInfo>
            {sponsor.logoUrl && (
              <SponsorLogo 
                src={`${process.env.REACT_APP_S3_URL}/${sponsor.logoUrl}`} 
                alt={sponsor.sponsorName} 
              />
            )}
            <div>
              <strong className="text-gray-900">{sponsor.sponsorName}</strong>
              {!sponsor.logoUrl && (
                <div className="mt-2">
                  <SponsorLogoUpload
                    onUploadComplete={(objectKey) => {
                      onLogoUpload(index, objectKey);
                    }}
                  />
                </div>
              )}
            </div>
          </SponsorInfo>
          <RemoveButton onClick={() => onRemoveSponsor(index)}>
            Remove
          </RemoveButton>
        </SponsorItem>
      ))}
    </SponsorSection>
  );
};

SponsorManagement.propTypes = {
  sponsors: PropTypes.array.isRequired,
  tempSponsorName: PropTypes.string.isRequired,
  onAddSponsor: PropTypes.func.isRequired,
  onRemoveSponsor: PropTypes.func.isRequired,
  onLogoUpload: PropTypes.func.isRequired,
  onTempSponsorNameChange: PropTypes.func.isRequired,
};

export default SponsorManagement; 